import { IErrorApiResponse, ISuccessApiResponse } from '@wyz/types';
import {
  OverridableQuery,
  restrictApi,
  useQuery,
  UseQueryOptions,
} from '@wyz/utils';
import { ConnectQueryKeys } from '~/connect/api';
import { useApi } from '~/common/context';
import { IInvoiceCompany } from '~/connect/types';

type Options = {
  list?: OverridableQuery<
    UseQueryOptions<ISuccessApiResponse<IInvoiceCompany[]>, IErrorApiResponse>
  >;
};

export const useManageInvoicingCompanies = <
  TRequestedKeys extends keyof Options,
  TRequestedOptions extends Options = Pick<Options, TRequestedKeys>,
>(
  options: TRequestedOptions,
) => {
  const { callCoreApi } = useApi();

  const listQuery = useQuery({
    queryKey: ConnectQueryKeys.invoicingCompany.base(),
    queryFn: () =>
      callCoreApi<ISuccessApiResponse<IInvoiceCompany[]>>(
        `/settings/api/companies`,
      ),
    ...options.list,
    gcTime: 0,
    enabled: Boolean(options.list?.enabled),
  });

  return restrictApi(options, {
    list: listQuery,
  });
};
